import { initialData } from '@/utils/analytics';
import { MediaTypes } from '@/models/analytics';
import { v4 as uuidv4 } from 'uuid';
import store from '@/store';
import SettingStorage, { storageLabels } from '@/utils/settings.storage';

import { apiGeneralService } from '@kidjo/kidjo-web-commons-services';

const apiService = apiGeneralService;
const state = {
    analyticsData: initialData(),
    media: {},
    query: {},
    apiKey: process.env.VUE_APP_API_KEY,
    apiUrl: process.env.VUE_APP_ANALYTICS_API,
};

const actions = {
    updateAnalyticsQuery({ commit }, payload) {
        commit('SetQuery', {
            data: payload?.title,
            category: payload.category,
        });
    },
    updateAnalyticsGameMedia({ commit }, payload) {
        commit('SetMedia', {
            id: payload?.identifier,
            title: payload.gameType,
            type: MediaTypes.GAMES,
            language: store.getters["settings/getLanguage"]?.toString() || 'en',
            isPremium: payload.isLocked,
            mediaCategory: store.getters['activeItem/getActiveItem'].mediaType
        });
    },
    resetAnalyticsGameMedia({ commit }, payload) {
       commit('SetMedia', {});
    },
    updateAnalyticsMedia({ commit, getters }, payload) {
        commit('SetMedia', {
            id: payload?.id,
            title: payload.title,
            type: MediaTypes.VIDEO,
            language: store.getters["settings/getLanguage"]?.toString() || 'en',
            isPremium: payload.premium,
            mediaCategory: store.getters["settings/getContentType"].toString(),
        });
    },
    postAnalytics({ commit, getters }, payload) {
        const eventInfo = {
            event: payload,
            transactionUuid: uuidv4(),
        }
        const userInfo = {
            userId: Number(store.getters["account/getUserId"]),
            subscriptionId: Number(store.getters["account/getSubscriptionId"]),
            minAge: store.getters['settings/getAge']?.minAge || 3,
            maxAge: store.getters['settings/getAge']?.maxAge || 8,
            partner: {
                name: store.getters["account/getPartner"] || '',
            }
        };
        const analytics = {
          media: getters.getMedia,
          query: getters.getQuery,
          ...getters.getAnalyticsData,
          ...userInfo,
          ...eventInfo,
        };
        apiService
        .postAnalytics(
            localStorage.getItem('kidj_ut'),
            analytics,
            state.apiKey,
            state.apiUrl,
        )
        .then((response) => {
            // console.log('reponse:', response);
        })
        .catch((error) => {
            console.log(error);
        });
    },
};

const mutations = {
    SetAnalyticsData(state, payload) {
        state.analyticsData = Object.assign({}, payload);
    },
    SetMedia(state, payload) {
       state.media = Object.assign({}, payload);
    },
    SetQuery(state, payload) {
       state.query = Object.assign({}, payload);
    },
};

const getters = {
  getMedia (state) {
    return state.media;
  },
  getQuery (state) {
    return state.query;
  },
  getAnalyticsData (state) {
    return state.analyticsData;
  },
};

const namespaced = true;

export const analytics = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
